import { PrivateInterceptor } from '../../Base/interceptors/PrivateInterceptor'


export const getListAutorizacionUsoHilaza = async (data) => {
    const result = await PrivateInterceptor('Planning/AutorizacionUsoHilaza/getList', 'POST', data)
    return result;
}
export const getEstadosUsoHilaza = async () => {
    const result = await PrivateInterceptor('Planning/AutorizacionUsoHilaza/getEstados', 'GET')
    return result;
}
export const autUsoHilaza = async (data) => {
    const result = await PrivateInterceptor('Planning/AutorizacionUsoHilaza/authHilaza', 'POST', data)
    return result;
}